export default "__VITE_ASSET__atKF8BoC__"